export const AVERAGE_IPD_METERS = 0.063;
export enum SimulatorRenderMode {
  DEFAULT = 'default',
  STEREO_LEFT = 'left',
  STEREO_RIGHT = 'right',
}
